import DetailsWrapper from 'components/Content/Happening/ReservationDetails/DetailsWrapper/DetailsWrapper';

export default DetailsWrapper;
